import { writable, get } from 'svelte/store';
export default class DataProvider {
    constructor(options) {
        this._placeholder = options.placeholder;
        this._cta = options.cta;
        this._ctaReset = options.reset;
        this._structureKeys = options.structureKeys;
        this._showSiteUrl = options.showSiteUrl;
        this._groupId = options.groupId;
        this._searchString = writable('');
        this._dateRange = writable('');
        this._actionType = writable('');
    }
    resetFilter() {
        this.searchString = '';
        this.dateRange = '';
        this.actionType = '';
    }
    get isFilterActive() {
        return !!(this.searchString || this.dateRange || this.actionType);
    }
    get placeholder() {
        return this._placeholder;
    }
    get cta() {
        return this._cta;
    }
    get ctaReset() {
        return this._ctaReset;
    }
    get showSiteUrl() {
        return this._showSiteUrl;
    }
    get groupId() {
        return this._groupId;
    }
    // searchString
    set searchString(string) {
        this._searchString.set(string);
    }
    get searchStringSubs() {
        return this._searchString;
    }
    get searchString() {
        return get(this._searchString);
    }
    get searchParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get("q") || "";
    }
    // filter
    // actionType / Typ akce
    set actionType(value) {
        this._actionType.set(value);
    }
    get actionType() {
        return get(this._actionType);
    }
    get typeParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get("typ") || '';
    }
    // dateRange
    set dateRange(string) {
        this._dateRange.set(string);
    }
    get dateRangeSubs() {
        return this._dateRange;
    }
    get dateRange() {
        return get(this._dateRange);
    }
    get dateRangeParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get("rozsah") || "";
    }
    // common
    get pageParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const page = urlParams.get("strana");
        return page ? parseInt(page) : 1;
    }
    get pageSizeParameterFromUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        const pageSize = urlParams.get("pocet");
        return pageSize ? parseInt(pageSize) : 6;
    }
    get apiStructureKeys() {
        if (typeof this._structureKeys === "string") {
            return this._structureKeys.split("|");
        }
        else {
            return [];
        }
    }
}
